// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'

Vue.use(Mint);

Vue.config.productionTip = false

document.addEventListener('touchstart', function(event) { if (event.touches.length > 1) { event.preventDefault(); } }, false);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        console.log(to.meta.title)
        document.title = to.meta.title
    }
    next()
})


// WEBPACK FOOTER //
// ./src/main.js